module.exports = __webpack_public_path__ + "ac51ad8a36d5bab6da11d454bcd06561.otf";